export default {
  currentUser: null,
  editUserDialog: false,
  contactFormDialog: false
}
